import React, { useContext, useState } from 'react';
import AppContext from '../context/AppContext';
import './Login.css';
import { Link, useNavigate } from 'react-router-dom';
import { postData, setToken } from '../services/request';
const Logo = 'https://i.postimg.cc/W47Xcyg3/UNI-DUNI-TE-MARCA-DAGUA-Prancheta-1.png';

function Login() {

  const { email, setEmail, setIsLogged } = useContext(AppContext);
  const [password, setPassword] = useState('');
  const [typeForm, setTypeForm] = useState('login');
  const [wrongData, setWrongData] = useState(false);
  const [passwordDifferent, setPasswordDifferent] = useState(false);
  const [invalidPassword, setInvalidPassword] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [emailNotAble, setEmailNotAble] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    phone: "",
    country: "Brasil",
    region: "",
    city: "",
    street: "",
    number: "",
    district: "",
    role: "customer"
  });

  const passwordValidation = () => {
    const password = formData.password;

    if (password.length < 6) {
      setInvalidPassword(true);
      return true;
    }

    if (formData.confirmPassword !== formData.password) {
      setPasswordDifferent(true)
      return true;
    }
  };

  const emailValidation = () => {
    const email = formData.email;
    const regex = /^[\w\.-]+@[\w\.-]+\.\w+$/;

    const test = regex.test(email)

    setInvalidEmail(!test);

    return !test;
  };

  const getUserRole = () => {
    const login = JSON.parse(sessionStorage.getItem('login'));
    if (login) {
      return login.user.role;
    }
    return false;
  };

  const getUserToken = () => {
    const login = JSON.parse(sessionStorage.getItem('login'));
    if (login) {
      return login.token;
    }
    return false;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setWrongData(false);
    setInvalidPassword(false);
    setPasswordDifferent(false);
    setInvalidEmail(false);
    setEmailNotAble(false);
    if (typeForm === 'login' && name === 'email') {
      setEmail(value);
    }
    if (typeForm === 'login' && name === 'password') {
      setPassword(value);
    }
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const navigate = useNavigate();

  const login = async (e) => {
    e.preventDefault();

    try {
      const data = await postData(
        '/login',
        { email, password }
      );
      sessionStorage.setItem('login', JSON.stringify(data.message));
      setIsLogged(true);
      navigate('/');
    } catch (error) {
      console.log(error);
      setWrongData(true);
      console.log('erro de login')
    }
  };

  const createUser = async (e, tipo) => {
    e.preventDefault();

    if (passwordValidation() || emailValidation()) {
      return null
    }

    const endpoint = tipo === 'employee' ? '/employee' : '/users';
    try {
      if (endpoint === '/employee') {
        setToken(getUserToken());
      };
      await postData(
        endpoint,
        formData,
      );
      setTypeForm('login')
    } catch (error) {
      console.log(error)
      if (error.message === 'Request failed with status code 500') {
        setEmailNotAble(true);
      }
    }
  };

  const handleClick = (name) => {
    setTypeForm(name);
  };

  const renderLogin = () => {
    return (
      <form className="login-form">
        <label>
          e-mail
        </label>
        <input
          className="login-input"
          name="email"
          type="text"
          onChange={(e) => handleChange(e)}
          value={email}
        />
        <label>
          senha
        </label>
        <input
          className="login-input"
          name="password"
          type="password"
          onChange={(e) => handleChange(e)}
          value={password}
        />
        {
          wrongData ? <p>e-mail ou senha incorretos</p> : null
        }
        <button className="login-btn" type="button" onClick={login}>Entrar</button>
      </form>
    )
  };

  const renderCadastro = () => {
    return (
      <form className="login-form">
      <label>
        Nome
      </label>
      <input
        className="login-input"
        name="name"
        type="text"
        onChange={handleChange}
        value={formData.name}
      />
      <label>
        E-mail
      </label>
      <input
        className="login-input"
        name="email"
        type="text"
        onChange={handleChange}
        value={formData.email}
      />
      <label>
        Senha
      </label>
      <input
        className="login-input"
        name="password"
        type="password"
        onChange={handleChange}
        value={formData.password}
      />
      <label>
        Confirmar Senha
      </label>
      <input
        className="login-input"
        name="confirmPassword"
        type="password"
        onChange={handleChange}
        value={formData.confirmPassword}
      />
      <label>
        Telefone
      </label>
      <input
        className="login-input"
        name="phone"
        type="text"
        onChange={handleChange}
        value={formData.phone}
      />
      <label>
        País
      </label>
      <input
        className="login-input"
        name="country"
        type="text"
        onChange={handleChange}
        value={formData.country}
      />
      <label>
        Estado
      </label>
      <input
        className="login-input"
        name="region"
        type="text"
        onChange={handleChange}
        value={formData.region}
      />
      <label>
        Cidade
      </label>
      <input
        className="login-input"
        name="city"
        type="text"
        onChange={handleChange}
        value={formData.city}
      />
      <label>
        Rua
      </label>
      <input
        className="login-input"
        name="street"
        type="text"
        onChange={handleChange}
        value={formData.street}
      />
      <label>
        Número
      </label>
      <input
        className="login-input"
        name="number"
        type="text"
        onChange={handleChange}
        value={formData.number}
      />
      <label>
        Bairro
      </label>
      <input
        className="login-input"
        name="district"
        type="text"
        onChange={handleChange}
        value={formData.district}
      />
      {
        getUserRole() === 'admin' ? (
          <label>
            Tipo
          <select name="role" onChange={(e) => handleChange(e)}>
            <option value="customer">Cliente</option>
            <option value="admin">Administrador</option>
            <option value="seller">Vendedor</option>
          </select>
          </label>
        ) : null
      }
      {
        getUserRole() === 'admin' ? (
          <button className="login-btn" type="button" onClick={(e) => createUser(e, 'employee')}>
            Cadastrar
          </button>
        ) : (
        <button className="login-btn" type="button" onClick={(e) => createUser(e, 'users')}>
          Cadastrar
        </button>
        )
      }
      {
        passwordDifferent ? <p>senhas divergentes</p> : null
      }
      {
        invalidPassword ? <p>a senha deve conter pelo menos 6 digitos</p> : null
      }
      {
        invalidEmail ? <p>verifique o e-mail informado</p> : null
      }
      {
        emailNotAble ? <p>e-mail não disponível</p> : null
      }
    </form>
    )
  };

  return (
    <main className="page-container">
      <section className="login-container">
        <img className="logo-hg" src={Logo} alt="logo-unidunite.png" />
        <div className="login-page-render-control">
          <button
            name="login"
            onClick={() => handleClick("login")}
            className={
              `type-login-button ${typeForm === 'login' ? "shine" : null}`
              }
            >
              Login
            </button>
            <button
            name="cadastro"
            onClick={() => handleClick("cadastro")}
            className={
              `type-login-button ${typeForm === 'cadastro' ? "shine" : null}`
              }
            >
              Cadastro
            </button>
        </div>
        {
          typeForm === "login" ? (renderLogin()) : (renderCadastro())
        }        
      </section>
      
    </main>
  );
}

export default Login;
